import script from "./Concat.vue?vue&type=script&setup=true&lang=js"
export * from "./Concat.vue?vue&type=script&setup=true&lang=js"

import "./Concat.vue?vue&type=style&index=0&id=8f4bae3e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f4bae3e"]])

export default __exports__